import paper from "paper";
import { makePaperProject } from "./utils.js";
import { each, eachL, go, takeAll } from "fxjs/es";

const roundToDec = (val, palaces) => {
  return +val.toFixed(palaces);
};

const getAllPathsNotClipMask = (item) => {
  if (item instanceof paper.Path) {
    if (!item.clipMask) {
      return [item];
    } else {
      return [];
    }
  } else {
    return item.getItems({
      class: paper.Path,
      clipMask: false,
    });
  }
};
const getPenUpPoint = (path) => {
  return path.closed ? path.firstSegment.point : path.lastSegment.point;
};

const getViewBoxFromSVG = (svg_el) => {
  const view = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  };
  const view_box_str = svg_el.getAttribute("viewBox");
  if (view_box_str) {
    const size_el = view_box_str.split(" ");
    view.x = Number(size_el[0]);
    view.y = Number(size_el[1]);
    view.width = Number(size_el[2]);
    view.height = Number(size_el[3]);
  }
  return view;
};

const getTimeVariableSpeed = (length, vi, vf, a, t1, l1) => {
  if (length < 2 * l1) {
    //상승 + 하강 최소 구간 길이 l1보다 짧은 경우
    return (2 * (-vi + Math.sqrt(vi * vi + a * length))) / a;
    // return length / vi;
  } else {
    //상승 + 하강 최소 구간 길이 l1보다 길면 최고 속도 구간이 추가됨.
    return 2 * t1 + (length - 2 * l1) / vf;
  }
};

const pathToTime = (pen_updown_time, distance, vi, vf, a, t1, l1) => {
  let total_time = pen_updown_time; // sec
  const default_segment_moving_time = 0.01;
  if (distance instanceof paper.Path) {
    go(
      distance.curves,
      each((c) => {
        const tangent_a = c.getTangentAtTime(0);
        const tangent_b = c.next.getTangentAtTime(0);

        if (tangent_a.x * tangent_b.x < 0 || tangent_a.y * tangent_b.y < 0) {
          total_time += default_segment_moving_time * 3;
        }
        total_time += default_segment_moving_time;
        if (!c.isStraight()) {
          //straight 하지 않는 경우 a = 0; 으로 간주, vf = vi
          total_time += c.length / vi;
        } else {
          //straight한 경우, 가속도의 지배를 받음
          total_time += getTimeVariableSpeed(c.length, vi, vf, a, t1, l1);
        }
      })
    );
  } else {
    //distance integer인 경우 (moving시 무조건 straight line)
    total_time += getTimeVariableSpeed(distance, vi, vf, a, t1, l1);
  }
  return total_time;
};

export const getPlotterCutTime = (svg_el) => {
  const vi = 180;
  const vf = 600;
  const a = 6000;
  const pen_updown_time = 0.05;
  // v = mm/s, a = mm/s2, l1 = mm, t1 = sec
  const t1 = (vf - vi) / a;
  const l1 = 0.5 * (vf + vi) * t1;
  // console.log("t1", t1, "l1", l1);
  let paper_scope = new paper.PaperScope();
  // window.paper_scope = paper_scope;
  paper_scope.activate();
  const view_size = getViewBoxFromSVG(svg_el);
  let cut_time = 0;
  let move_time = 0;
  let last_pen_up_point = new paper_scope.Point(0, 0);
  makePaperProject(
    paper_scope,
    svg_el.width || view_size.width,
    svg_el.height || view_size.height
  );
  paper_scope.project.importSVG(svg_el, {
    onLoad: (item) => {
      go(
        getAllPathsNotClipMask(item),
        eachL((path) => {
          cut_time += pathToTime(pen_updown_time, path, vi, vf, a, t1, l1);
          move_time += pathToTime(
            pen_updown_time,
            last_pen_up_point.getDistance(path.firstSegment.point),
            vi,
            vf,
            a,
            t1,
            l1
          );
          last_pen_up_point = getPenUpPoint(path);
        }),
        takeAll
      );
    },
    expandShapes: true,
  });
  paper_scope.remove();
  paper_scope = null;
  cut_time = roundToDec(cut_time, 2);
  move_time = roundToDec(move_time, 2);
  const total_time = cut_time + move_time;
  return { cut_time, move_time, total_time };
};

const view_el = document.getElementById("view");
export const getClosestDistanceBetweenPath = (pathdata_arr) => {
  let paper_scope = new paper.PaperScope();
  paper_scope.activate();
  makePaperProject(paper_scope, 500, 500, view_el);
  const target_distance = 10;
  let distance;
  if (pathdata_arr.length > 2) pathdata_arr = pathdata_arr.slice(0, 2);
  const path_a = new paper_scope.Path(pathdata_arr[0]);
  const path_b = new paper_scope.Path(pathdata_arr[1]);
  path_a.set({
    strokeColor: "red",
    strokeWidth: 3,
  });
  path_b.set({
    strokeColor: "green",
    strokeWidth: 3,
  });
  let point_a = (path_a.data.checkpoint = path_a.firstSegment.point);
  let point_b = (path_b.data.checkpoint = path_b.getNearestPoint(point_a));
  point_a = path_a.data.checkpoint = path_a.getNearestPoint(point_b);
  distance = point_a.getDistance(point_b);
  const path_distance = new paper_scope.Path([point_a, point_b]);
  path_distance.set({
    strokeColor: "black",
    strokeWidth: 2,
  });
  if (distance > target_distance) {
  }
};
